// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"f150b82c","150":"91968e1c","226":"2663f061","312":"8de9cdc7","629":"750f39b7","747":"3cb9548c","954":"7ba57887"}[chunkId] + ".chunk.js";
};